import React from 'react'
import { Redirect } from 'react-router-dom'

import { authTokenStoreService } from '../../services/authTokenStoreService'
import { routes } from '../../constants/routes'

export const AuthProtect = ({ children }) => {
  const isLogged = authTokenStoreService.isLogged()

  return isLogged ? children : <Redirect to={routes.LOGIN} />
}
